<!--<script-->
<!--  src="../../../../../../../Parcel/front-end/src/app/Parcel/customer-manage/customer-manage.component.ts"></script>-->
<!--<div class="card card-box mb-5">-->
<!--  <div class="card-header py-3">-->
<!--    <div class="card-header&#45;&#45;title font-size-lg">-->
<!--      <b><i class="fas fa-cog"></i> Packages </b>-->
<!--    </div>-->
<!--    <div class="card-header&#45;&#45;actions">-->
<!--      &lt;!&ndash;      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="createModal()">&ndash;&gt;-->
<!--      &lt;!&ndash;                <span class="btn-wrapper&#45;&#45;icon">&ndash;&gt;-->
<!--      &lt;!&ndash;                    <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>&ndash;&gt;-->
<!--      &lt;!&ndash;                </span>&ndash;&gt;-->
<!--      &lt;!&ndash;        <span class="btn-wrapper&#45;&#45;label">&ndash;&gt;-->
<!--      &lt;!&ndash;                    New User&ndash;&gt;-->
<!--      &lt;!&ndash;                </span>&ndash;&gt;-->
<!--      &lt;!&ndash;      </button>&ndash;&gt;-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="d-flex justify-content-between px-4 py-3">-->
<!--    <div class="search-wrapper">-->
<!--          <span class="icon-wrapper text-black">-->
<!--            <fa-icon [icon]="['fas', 'search']"></fa-icon>-->
<!--          </span>-->
<!--      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="divider"></div>-->
<!--  <div class="table-responsive">-->
<!--    <table class="table table-hover text-nowrap mb-0">-->
<!--      <thead>-->
<!--      <tr>-->
<!--        <th class="bg-white text-center">ID</th>-->
<!--        <th class="bg-white text-center">PACKAGE NAME</th>-->
<!--        <th class="bg-white text-center">TYPE</th>-->
<!--        <th class="bg-white text-center">CATEGORY</th>-->
<!--        <th class="bg-white text-center">PRICE</th>-->
<!--        <th class="bg-white text-center">ADD ITENARY</th>-->
<!--        <th class="bg-white text-center">ACTIONS</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <tr *ngFor="let pac of packages">-->
<!--        <td class="font-weight-bold text-center">-->
<!--          # {{pac.id}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{pac.packageName}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{pac.packageCategory.category}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{pac.packagePrice}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{pac.username}}-->
<!--        </td>-->
<!--        <td class="font-weight-bold text-center">-->
<!--          <button type="button" class="btn btn-success btn-sm" (click)="add(pac)">-->
<!--            <i class="fas fa-plus"></i>-->
<!--          </button>-->
<!--        </td>-->

<!--        <td class="text-center">-->
<!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
<!--            &lt;!&ndash;            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>&ndash;&gt;-->
<!--            <button type="button" class="btn btn-warning" (click)="update(pac.itenary)">-->
<!--              <i class="fas fa-edit"></i>-->
<!--            </button>-->
<!--            <button type="button" class="btn btn-danger" (click)="packageDelete(errorModal,pac.id)"><i-->
<!--              class="far fa-trash-alt"></i></button>-->
<!--            &lt;!&ndash;            <button type="button" class="btn btn-success" (click)="packageUpdate(pac.id)" ><i class="fas fa-check-circle"></i></button>&ndash;&gt;-->
<!--          </div>-->
<!--        </td>-->
<!--      </tr>-->

<!--      </tbody>-->
<!--    </table>-->
<!--  </div>-->
<!--  <div class="card-footer py-3 d-flex justify-content-between">-->

<!--  </div>-->
<!--</div>-->
<!--&lt;!&ndash;===========================delete Model===================================&ndash;&gt;-->
<!--<ng-template #errorModal>-->
<!--  <div class="text-center p-5">-->
<!--    <div class="avatar-icon-wrapper rounded-circle m-0">-->
<!--      <div-->
<!--        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">-->
<!--        <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>-->
<!--      </div>-->
<!--    </div>-->
<!--    <h4 class="font-weight-bold mt-4">Are you sure you want to delete this entry?</h4>-->
<!--    <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p>-->
<!--    <div class="pt-4">-->
<!--      <button (click)="declineDelete()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">-->
<!--                <span class="btn-wrapper&#45;&#45;label">-->
<!--                    Cancel-->
<!--                </span>-->
<!--      </button>-->
<!--      <button (click)="confirmDelete()" class="btn btn-pill btn-danger mx-1" type="button">-->
<!--                <span class="btn-wrapper&#45;&#45;label">-->
<!--                    Delete-->
<!--                </span>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->


<!--<div bsModal #upModal="bs-modal" class="modal fade" tabindex="-1"-->
<!--     role="dialog" aria-labelledby="dialog-sizes-name1">-->
<!--  <div class="modal-dialog modal-dialog-centered modal-lg">-->
<!--    <div class="modal-content">-->
<!--      <div class="modal-header">-->
<!--        <h6 class="modal-title">Large modal</h6>-->
<!--        <button type="button" class="close" (click)="upModal.hide()" aria-label="Close">-->
<!--          <span aria-hidden="true">&times;</span>-->
<!--        </button>-->
<!--      </div>-->
<!--      <div class="modal-body">-->
<!--        <perfect-scrollbar style="height: 28rem">-->
<!--          <table class="table table-hover text-nowrap table-borderless mb-0">-->
<!--            <thead>-->
<!--            <tr>-->
<!--              <th class="">ITENARY</th>-->
<!--              <th class="text-center">ACTION</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr *ngFor="let ex of itenarys" class="cusror-point" style="cursor: pointer" (click)="itenaryClick(ex)">-->
<!--              <td class="font-weight-bold ">{{ex.description}}</td>-->
<!--              <td class="text-center">-->
<!--                <button type="button" class="btn btn-danger btn-sm " (click)="remove(ex.description)">-->
<!--                  <i class="far fa-trash-alt"></i></button>-->
<!--              </td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--          </table>-->
<!--        </perfect-scrollbar>-->
<!--      </div>-->
<!--      <div class="modal-footer">-->
<!--        <button type="button" class="btn btn-link btn-link-dark" (click)="upModal.hide()">Close</button>-->
<!--&lt;!&ndash;        <button type="button" class="btn btn-primary ml-auto" [di (click)="createItenary()">Save changes</button>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<div class="card">
  <div class="card-body">
    <h3><b>Itenary Manage</b></h3>
    <p class="text-muted">please select the package to manage itenary details</p>
    <hr>
    <form [formGroup]="itForm">
      <div class="row">
        <div class="col-3">
          <label for="pacName">Package name</label>
          <input id="pacName" formControlName="pName" type="text" class="form-control">
        </div>
        <div class="col-3">
          <label for="ppro">Category</label>
          <select id="ppro" formControlName="categoryId" class="form-control mb-2" placeholder="Catagory" type="text">
            <option disabled value="x">Category</option>
            <option *ngFor="let c of catgorys" value="{{c.id}}">{{c.category}}</option>
          </select>
        </div>
        <div class="col-3">
          <label for="ptype">Type</label>
          <select id="ptype" formControlName="type" class="form-control mb-2" placeholder="Catagory" type="text">
            <option *ngFor="let c of type" value="{{c.id}}">{{c.type}}</option>
          </select>
        </div>
        <div class="col-3">
          <label for="ptype"></label>
          <button class="btn btn-info ml-3" style="margin-top: 28px; margin-right: 20px" (click)="searchPackages(1)">
            Search
          </button>
          <button class="btn btn-secondary" style="margin-top: 28px;" (click)="reset()">
            <i class="fas fa-sync-alt"></i></button>
        </div>
      </div>
    </form>
    <div class="col-12 mt-3 mb-3">
      <div class="table-responsive">
        <perfect-scrollbar style="height: 20rem">
          <table class="table table-hover text-nowrap mb-0">
            <thead>
            <tr>
              <th class="bg-white ">PACKAGE NAME</th>
              <th class="bg-white text-center">CATEGORY</th>
              <th class="bg-white text-center">PRICE</th>
              <th class="bg-white text-center">TYPE</th>


            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let pac of packages" (click)="packSelect(pac.id,pac.itenary,pac)" style="cursor: pointer">

              <td class="font-weight-bold ">
                {{pac.packageName}}
              </td>
              <td class="font-weight-bold text-center">
                {{pac.packageCategory.category}}
              </td>
              <td class="font-weight-bold text-center">
                {{pac.packagePrice}}
              </td>
              <td class="font-weight-bold text-center">
                {{pac.travelType.type}}
              </td>
            </tr>

            </tbody>
          </table>
          <div class="card-footer py-3 d-flex justify-content-between">
            <pagination [totalItems]="totalRec" [(ngModel)]="currentPage" (pageChanged)="getallPackages($event.page)"
                        class="pagination-icons pagination-warning"></pagination>
          </div>
        </perfect-scrollbar>
      </div>

    </div>
    <div class="row">
      <div class="col-9">
        <p class="text-danger">After selecting package, below UI should display</p>
        <h3><b>Itenary Details : {{pacname}}</b></h3>
        <p class="text-muted">Create or modify iteneries below</p>
        <hr>
      </div>
      <div class="col-3">
        <button class="btn btn-success mb-3" [disabled]="packID==null" (click)="add()"> Create new</button>
      </div>


      <div class="col-12">

        <div class="col-md-6 my-2 p-0 mx-auto" dragula="VAMPIRES"  [(dragulaModel)]="itDetail">
          <div class="card card-box px-4 py-2 m-2 font-weight-bold text-center" *ngFor="let i of itDetail">{{i.description}}
            <div class="btn-group">
              <button class="btn btn-neutral-warning btn-sm" (click)="up(i)">
                <i class="fas fa-edit" style="font-size: 15px;"></i>
                Update
              </button>
              <button class="btn btn-neutral-danger btn-sm" (click)="dlt(i)">
                <i class="fas fa-times-circle" style="font-size: 15px;"></i>
                Delete
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-9"></div>
          <div class="col-3">
            <button class="btn btn-success" (click)="vamp()">Arange list</button>
          </div>

        </div>



        <!--        <perfect-scrollbar>-->
        <!--          <div *ngFor="let i of itDetail" class="card border-1 mb-3" style="border-color: #c7c7c7">-->
        <!--            <div class="card-body" style="    padding: .75rem;">-->
        <!--              <div class="row">-->
        <!--                <div class="col-9 border-right-1">-->
        <!--                  <h4>{{i.description}}</h4>-->
        <!--                </div>-->
        <!--                <div class="col-1">-->
        <!--                  <button class="btn btn-warning btn-sm" (click)="up(i)">-->
        <!--                    <i class="fas fa-edit" style="font-size: 15px;"></i>-->
        <!--                    Update-->
        <!--                  </button>-->

        <!--                </div>-->
        <!--                <div class="col-1">-->
        <!--                  <button class="btn btn-danger btn-sm" (click)="dlt(i)">-->
        <!--&lt;!&ndash;                    <i class="fas fa-times-circle" style="font-size: 15px;"></i>&ndash;&gt;-->
        <!--                    Delete-->
        <!--                  </button>-->

        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->

        <!--        </perfect-scrollbar>-->
      </div>

    </div>
  </div>
</div>

<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Add Itenary</h6>
        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="packForm">
          <div class="row">
            <div class="col-12">
              <h4><b>Create itenary</b></h4>
              <p class="text-muted">please fill all requierd fields to create itenary</p>
              <input formControlName="title" class="form-control mb-2" placeholder=" Itenray Title" type="text">
            </div>
            <div class="col-12 mb-3">
              <ngx-dropzone (change)="onSelect($event)">
                <ngx-dropzone-label>Drop!</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                  <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>

            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h4><b>Create itenary description</b></h4>
              <p class="text-muted">please fill all requierd fields to create itenary</p>
              <div class="input-group">
                <input formControlName="desc" class="form-control mb-2" placeholder="Description" type="text">
                <button class="btn btn-success" style="height: calc(1.5em + 1.06rem + 2px);" (click)=" descadd()"><i
                  class="fas fa-plus"></i>
                </button>
              </div>
              <hr>

              <perfect-scrollbar>
                <div *ngFor="let i of desc" class="card border-1 mb-3" style="border-color: #c7c7c7">
                  <div class="card-body" style="    padding: .75rem;">
                    <div class="row">
                      <div class="col-10 border-right-1">
                        <h5><b>{{i.description}}</b></h5>
                      </div>
                      <div class="col-1">
                        <button class="btn btn-danger btn-sm" (click)="removeDesc(i.description)">
                          <i class="fas fa-times-circle" style="font-size: 15px;"></i>
                        </button>

                      </div>
                    </div>
                  </div>
                </div>

              </perfect-scrollbar>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>
        <button *ngIf="isup==false" style="z-index: 99999999" type="button" class="btn btn-success ml-auto"
                [disabled]="!packForm.valid || desc.length==0" (click)="createItenary()">Save changes
        </button>
        <button *ngIf="isup!=false" style="z-index: 99999999" type="button" class="btn btn-warning ml-auto"
                [disabled]="!packForm.valid || desc.length==0" (click)="updateItenary()">Update
        </button>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
